"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCredentials = clearCredentials;
const Amplify_1 = require("../Amplify");
function clearCredentials() {
    return Amplify_1.Amplify.Auth.clearCredentials();
}
